<script setup>
import { onMounted, ref } from 'vue'
import AppButton from '#/general/AppButton'
import AppDialog from '#/general/AppDialog'
import { useGA } from '#/useGA'
const { event } = useGA()
const visible = ref(false)
onMounted(() => {
  setTimeout(() => {
    if (!localStorage.getItem('cookie-accepted')) visible.value = true
  }, 3500)
})
const acceptCookies = () => {
  localStorage.setItem('cookie-accepted', 'true')
  visible.value = false
}

const navigateToPrivacyPolicy = () => {
  event('button', { eventCategory: 'button', eventLabel: 'Mehr erfahren. - Privacy Policy' })
}
</script>

<template lang="pug">
app-dialog(v-model:show-modal="visible" seamless transition="float" full-width position="bottom" fixed)
  template(#modal-content)
    .cookieConsentDialog
      .consentContainer
        .consentMainContent
          .row
            .textBody Wir verwenden Cookies.
            router-link.textBody(style="text-decoration: underline" to="/privacy-policy" @click="navigateToPrivacyPolicy").cursor-pointer Mehr erfahren.
          app-button(@click="acceptCookies" label="Einverstanden" :style="$q.screen.lt.md ? 'padding: 0px 5px !important' : ''" padding="0 15px")
</template>

<style lang="sass">
.cookieConsentDialog
  .consentContainer
    background: #2F3849
    min-height: 79px
    width: 100%
    display: flex
    justify-content: center
    padding: 10px 0
    align-items: center
    .consentMainContent
      height: 100%
      display: flex
      flex-direction: row
      justify-content: space-between
      align-items: center
      @media screen and (min-width: 1450px)
        width: 80% !important
      @media screen and (min-width: 1250px)
        width: 90%
      @media screen and (max-width: 1250px)
        width: 95%
      .textBody
        font-weight: 500
        line-height: 140%
        color: #FFFFFF
        @media screen and (min-width: 1024px)
          font-size: 24px
          margin-right: 10px
        @media screen and (max-width: 1023px)
          font-size: 16px
          margin-right: 5px
      .acceptBtn
        background: #0386f9
        border-radius: 8px
        display: flex
        justify-content: center
        align-items: center
        cursor: pointer
        box-shadow: 0 1px 1px 0 rgba(36,36,36,0.2)
        -webkit-box-shadow: 0 1px 1px 0 rgba(36,36,36,0.2)
        -moz-box-shadow: 0 1px 1px 0 rgba(36,36,36,0.2)
        @media screen and (min-width: 1250px)
          padding: 10px
          height: 52px
        @media screen and (max-width: 1250px)
          padding: 7px
          height: 40px
        @media screen and (max-width: 600px)
          padding: 10px !important
          height: 30px
        .btnLabel
          color: white
          font-weight: 500
          @media screen and (min-width: 1250px)
            font-size: 18px
          @media screen and (max-width: 1250px)
            font-size: 16px
          @media screen and (max-width: 600px)
            font-size: 14px
</style>
